const ImageData={
    name : [
{
    id:1,
    name: "Images/slideshowImages/bg1.jpg",
    alt:"background1"
 },
 {
    id:2,
    name: "Images/slideshowImages/bg1.jpg",
    alt:"background1"
 }
]
}
const bannerReducer =(state=ImageData,action)=>{
    return state;
}
   
 
 export default bannerReducer;